export const SET_CASH_REGISTER = "SET_CASH_REGISTER";
export const SET_CASH_REGISTERS = "SET_CASH_REGISTERS";
export const ADD_CASH_REGISTER = "ADD_CASH_REGISTER";
export const UPDATE_CASH_REGISTER = "UPDATE_CASH_REGISTER";
export const DELETE_CASH_REGISTER = "DELETE_CASH_REGISTER";
export const SET_CASH_REGISTER_ORDERS = "SET_CASH_REGISTER_ORDERS";
export const SET_CASH_REGISTER_ORDERS_CANCELED = "SET_CASH_REGISTER_ORDERS_CANCELED";
export const DELETE_CASH_REGISTER_ORDER = "DELETE_CASH_REGISTER_ORDER";
export const ADD_CASH_REGISTER_ORDER_CANCELED = "ADD_CASH_REGISTER_ORDER_CANCELED";
export const SET_CASH_REGISTER_REPORT_PRODUCTS = "SET_CASH_REGISTER_REPORT_PRODUCTS";
export const SET_CASH_REGISTER_REPORT_TOTALS = "SET_CASH_REGISTER_REPORT_TOTALS";
export const SET_CASH_REGISTER_REPORT_CLOSE = "SET_CASH_REGISTER_REPORT_CLOSE";
export const SET_CASH_REGISTER_PAYMENT_METHODS = "SET_CASH_REGISTER_PAYMENT_METHODS";
export const SET_CASH_REGISTER_SHIFT = "SET_CASH_REGISTER_SHIFT";
